export enum AssetsProfileTab {
  ASSETS = 'Assets',
  SOFTWARE = 'Software',
}
